<template>
  <!-- 一个照片盒子 -->
  <div class="id_6 clear">
    <div class="img_box imgBox" :style="data.bol ? {'zoom': (data.zoom ? data.zoom : '100%')} : {'width': (data.zoom ? data.zoom : '100%')}">
      <a :href="data.url" target="_blank" v-if="data.url">
        <img ref="img" :src="data.src">
      </a>
      <img ref="img" :src="data.src" v-else>
    </div>
    <div class="title" v-if="data.title" v-html="data.title"></div>
  </div>
</template>

<script>

export default {
  props: {
    data: Object
  },
  name: 'id_6',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.id_6{
  word-wrap:break-word;
  padding-top: 24px;
  background-color: #fff;
  text-align: center;
  .img_box{
    max-width: 100%;
    font-size: 0;
    line-height: 0;
    img{
      width: 100%;
    }
  }
  .imgBox{
    display: inline-block;
  }
  .title{
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    color: #909399;
    margin-top: 16px;
    white-space: pre-wrap;
    word-break: break-word;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/course/public/id_6.vue